<template>
  <div class="mt-4 px-4 container-fluid">
    <!-- Breadcrumb -->
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/')">Inicio</span>
        &gt;
        <span>Landing Servicios</span>
      </p>
    </div>

    <!-- Toolbar -->
    <div class="ls-toolbar mb-3">
      <div class="ls-toolbar-left">
        <select v-model="filtroTipster" class="ls-select" @change="paginaActual=1; cargar()">
          <option value="">Todos los tipsters</option>
          <option v-for="t in tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
        </select>
        <select v-model="filtroEstado" class="ls-select" @change="paginaActual=1; cargar()">
          <option value="">Todos los estados</option>
          <option value="borrador">Borrador</option>
          <option value="publicada">Publicada</option>
          <option value="pausada">Pausada</option>
        </select>
      </div>
      <button class="btn-ls-primary" @click="abrirCrear()">+ Nueva Landing</button>
    </div>

    <!-- Estado carga -->
    <div v-if="cargando" class="text-center py-5 opacity-6">Cargando...</div>
    <div v-else-if="error" class="ls-alert ls-alert--err">{{ error }}</div>

    <!-- Tabla -->
    <div v-else class="ls-table-wrap">
      <div v-if="landings.length === 0" class="text-center py-5 opacity-6">
        No hay landing de servicios creadas.
      </div>
      <table v-else class="table table-flush table-listado">
        <thead class="thead-light">
          <tr>
            <th>Tipster</th>
            <th>Servicio</th>
            <th class="d-none d-md-table-cell">Personalización</th>
            <th class="d-none d-md-table-cell">Idioma</th>
            <th>Estado</th>
            <th>URL pública</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody class="text-sm">
          <tr v-for="l in landings" :key="l.id">
            <td>{{ l.tipster_nombre }}</td>
            <td>{{ l.producto_nombre }}</td>
            <td class="d-none d-md-table-cell">{{ l.personalizacion_nombre }}</td>
            <td class="d-none d-md-table-cell">
              <span class="lnd-badge lnd-badge--idioma">{{ l.idioma }}</span>
            </td>
            <td>
              <span class="lnd-estado" :class="'lnd-estado--' + l.estado">{{ l.estado }}</span>
            </td>
            <td>
              <div class="ls-url-cell">
                <span class="ls-url-text" :title="l.url_publica">{{ l.slug_publico }}</span>
                <a href="#" class="cursor-pointer me-1" title="Copiar URL" @click.prevent="copiarUrl(l.url_publica)"><i class="fa fa-copy text-secondary"></i></a>
                <a v-if="l.estado === 'publicada'" :href="l.url_publica" target="_blank" class="cursor-pointer" title="Abrir landing"><i class="fa fa-external-link-alt text-secondary"></i></a>
              </div>
            </td>
            <td class="lnd-acciones">
              <a href="#" class="cursor-pointer me-2" title="Vista previa móvil" @click.prevent="verPrevia(l)"><i class="fas fa-mobile-alt text-secondary"></i></a>
              <a href="#" class="cursor-pointer me-2" title="Editar personalización" @click.prevent="abrirEditar(l)"><i class="fas fa-edit text-secondary"></i></a>
              <a v-if="puedeCampanaMeta && l.estado === 'publicada'" href="#" class="cursor-pointer me-2" title="Campaña Meta Ads" @click.prevent="abrirMeta(l)">
                <i class="fab fa-meta" :style="{ color: l.meta_campaign_id ? '#1877f2' : '#9ca3af' }"></i>
              </a>
              <a v-if="l.estado !== 'publicada'" href="#" class="cursor-pointer me-2" title="Publicar" @click.prevent="publicar(l)"><i class="fas fa-check-circle text-success"></i></a>
              <a v-if="l.estado === 'publicada'" href="#" class="cursor-pointer me-2" title="Pausar" @click.prevent="pausar(l)"><i class="fas fa-pause-circle text-warning"></i></a>
              <a href="#" class="cursor-pointer" title="Eliminar" @click.prevent="confirmarBorrar(l)"><i class="fas fa-trash text-secondary"></i></a>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginación -->
      <div v-if="totalPaginas > 1" class="ls-pag mt-3">
        <button class="ls-pag-btn" :disabled="paginaActual<=1" @click="paginaActual--;cargar()">&lsaquo;</button>
        <span class="ls-pag-info">{{ paginaActual }} / {{ totalPaginas }}</span>
        <button class="ls-pag-btn" :disabled="paginaActual>=totalPaginas" @click="paginaActual++;cargar()">&rsaquo;</button>
      </div>
    </div>
  </div>

  <!-- Modal: Crear landing -->
  <div v-if="modalCrear" class="modal-overlay" @click.self="modalCrear=false">
    <div class="ls-modal ls-modal--crear">
      <div class="ls-modal-header">
        <span><i class="fa fa-rocket me-2 text-gold"></i>Nueva Landing de Servicio</span>
        <button class="det-close" @click="modalCrear=false">✕</button>
      </div>
      <div class="ls-modal-body">

        <!-- Sección: Tipster y servicio -->
        <div class="ls-section-label">1. Tipster y servicio</div>
        <div class="ls-form-field">
          <label>Tipster *</label>
          <select v-model="crear.tipster_id" class="ls-select ls-select--full" @change="cargarServicios(); cargarPersonalizaciones()">
            <option value="">Selecciona tipster</option>
            <option v-for="t in tipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
          </select>
        </div>
        <div class="ls-form-field">
          <label>Servicio *</label>
          <select v-model="crear.producto_id" class="ls-select ls-select--full" :disabled="!crear.tipster_id || cargandoServicios" @change="onSeleccionarServicio">
            <option value="">{{ cargandoServicios ? 'Cargando servicios...' : 'Selecciona servicio' }}</option>
            <option v-for="p in servicios" :key="p.id" :value="p.id">{{ p.nombre }}</option>
          </select>
        </div>

        <!-- Info del servicio seleccionado -->
        <div v-if="servicioSeleccionado" class="ls-servicio-info">
          <span v-if="servicioSeleccionado.precio_rebajado" class="ls-info-chip"><s class="opacity-5">{{ servicioSeleccionado.precio }} {{ servicioSeleccionado.moneda }}</s> → <strong>{{ servicioSeleccionado.precio_rebajado }} {{ servicioSeleccionado.moneda }}</strong></span>
          <span v-else class="ls-info-chip">💰 {{ servicioSeleccionado.precio }} {{ servicioSeleccionado.moneda }}</span>
          <span class="ls-info-chip">{{ servicioSeleccionado.tipo_venta !== 'venta_unica' ? '🔄 Suscripción' : '🛒 Pago único' }}</span>
          <span v-if="servicioSeleccionado.tipo_venta !== 'venta_unica' && servicioSeleccionado.dias_gracia > 0" class="ls-info-chip ls-info-chip--gold">🎁 {{ servicioSeleccionado.dias_gracia }} días gratis</span>
        </div>

        <!-- Sección: Contenido (bloques) -->
        <div class="ls-section-label mt-3">2. Contenido *</div>
        <div class="ls-form-field">
          <button
            type="button"
            class="ls-btn-bloques"
            :disabled="!crear.tipster_id"
            @click="abrirBloques()"
          >
            <i class="fa fa-th-large me-1"></i>
            <span v-if="crear.bloques.length === 0">Configurar bloques de contenido</span>
            <span v-else>{{ crear.bloques.length }} bloque{{ crear.bloques.length > 1 ? 's' : '' }} configurado{{ crear.bloques.length > 1 ? 's' : '' }}</span>
            <i class="fa fa-chevron-right ms-auto opacity-5"></i>
          </button>
          <p v-if="!crear.tipster_id" class="ls-hint opacity-5 mt-1">Selecciona un tipster primero</p>
        </div>

        <!-- Plantilla base (opcional) -->
        <div class="ls-form-field">
          <label>Plantilla base <span class="ls-hint">(opcional — para colores e imágenes)</span></label>
          <select v-model="crear.tipster_landing_servicio_id" class="ls-select ls-select--full" :disabled="!crear.tipster_id || cargandoPersonalizaciones">
            <option value="">{{ cargandoPersonalizaciones ? 'Cargando...' : '— Sin plantilla base —' }}</option>
            <option v-for="p in personalizaciones" :key="p.id" :value="p.id">{{ p.nombre }} ({{ p.idioma }})</option>
          </select>
        </div>

        <!-- Sección: Precio -->
        <div class="ls-section-label mt-3">3. Precio</div>
        <div class="ls-toggle-row">
          <label class="ls-toggle-label">
            <input type="checkbox" v-model="crear.mostrar_precio" class="ls-toggle-input" />
            <span class="ls-toggle-track"><span class="ls-toggle-thumb"></span></span>
            Mostrar precio en la landing
          </label>
        </div>

        <div v-if="crear.mostrar_precio && servicioSeleccionado" class="ls-precio-panel">
          <div v-if="servicioSeleccionado.precio_rebajado" class="ls-precio-preview">
            Se mostrará: <s class="opacity-5">{{ servicioSeleccionado.precio }} {{ servicioSeleccionado.moneda }}</s> → <strong>{{ servicioSeleccionado.precio_rebajado }} {{ servicioSeleccionado.moneda }}</strong>
          </div>
          <div v-else class="ls-precio-preview">
            Se mostrará: <strong>{{ servicioSeleccionado.precio }} {{ servicioSeleccionado.moneda }}</strong>
          </div>
          <div v-if="servicioSeleccionado.tipo_venta !== 'venta_unica' && servicioSeleccionado.dias_gracia > 0" class="ls-gratis-badge">
            <i class="fa fa-gift me-1"></i> Se mostrarán <strong>{{ servicioSeleccionado.dias_gracia }} días gratis</strong> automáticamente
          </div>
        </div>

        <div v-if="errorCrear" class="ls-alert ls-alert--err mt-3">{{ errorCrear }}</div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn-secondary" @click="modalCrear=false">Cancelar</button>
        <button class="btn-ls-primary" :disabled="!puedeCrear || creando" @click="crearLanding()">
          <i v-if="creando" class="fa fa-spinner fa-spin me-1"></i>
          {{ creando ? 'Creando...' : 'Crear landing' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal: Editar landing -->
  <div v-if="modalEditar" class="modal-overlay" @click.self="modalEditar=false">
    <div class="ls-modal ls-modal--crear">
      <div class="ls-modal-header">
        <span><i class="fa fa-edit me-2 text-gold"></i>Editar — {{ editarTarget?.producto_nombre }}</span>
        <button class="det-close" @click="modalEditar=false">✕</button>
      </div>
      <div class="ls-modal-body">
        <!-- Info chips -->
        <div class="ls-servicio-info mb-3">
          <span class="ls-info-chip">👤 {{ editarTarget?.tipster_nombre }}</span>
        </div>

        <!-- Cambiar servicio -->
        <div class="ls-section-label">Servicio asociado</div>
        <div class="ls-form-field">
          <select v-model="editar.producto_id" class="ls-select ls-select--full" :disabled="cargandoServiciosEditar" @change="editar.cta_link = ''">
            <option value="">{{ cargandoServiciosEditar ? 'Cargando...' : '— Sin cambios —' }}</option>
            <option v-for="s in serviciosEditar" :key="s.id" :value="s.id">{{ s.nombre }}</option>
          </select>
        </div>
        <div v-if="editar.producto_id && serviciosEditar.length" class="ls-servicio-info mt-1 mb-2">
          <template v-for="s in serviciosEditar" :key="s.id">
            <template v-if="s.id == editar.producto_id">
              <span class="ls-info-chip">💰 {{ s.precio }} {{ s.moneda }}</span>
              <span class="ls-info-chip">{{ s.tipo_venta !== 'venta_unica' ? '🔄 Suscripción' : '🛒 Pago único' }}</span>
              <span v-if="s.tipo_venta !== 'venta_unica' && s.dias_gracia > 0" class="ls-info-chip ls-info-chip--gold">🎁 {{ s.dias_gracia }} días gratis</span>
            </template>
          </template>
        </div>

        <!-- Bloques de contenido -->
        <div class="ls-section-label">Bloques de contenido</div>
        <button type="button" class="ls-btn-bloques" @click="abrirBloques('editar')">
          <i class="fa fa-layer-group me-2"></i>
          <span v-if="editar.bloques.length === 0">Configurar bloques</span>
          <span v-else>Editar bloques <span class="ls-bloques-badge">{{ editar.bloques.length }}</span></span>
        </button>
        <div v-if="editar.bloques.length > 0" class="ls-bloques-preview mt-2">
          <span v-for="(b, i) in editar.bloques" :key="i" class="ls-blk-tag">
            <i :class="'fa ' + (tiposBloques.find(t=>t.tipo===b.tipo)?.icon || 'fa-cube') + ' me-1 opacity-7'"></i>{{ tiposBloques.find(t=>t.tipo===b.tipo)?.label || b.tipo }}
          </span>
        </div>

        <!-- Enlace CTA -->
        <div class="ls-section-label mt-3">Enlace del botón CTA</div>
        <div class="ls-form-field">
          <input
            v-model="editar.cta_link"
            type="url"
            class="ls-input ls-input--full"
            placeholder="https://... (se recalcula automáticamente al cambiar el servicio)"
          />
        </div>

        <!-- Personalización (opcional) -->
        <div class="ls-section-label mt-3">Personalización <span class="ls-hint">(colores, imágenes del tipster — opcional)</span></div>
        <div class="ls-form-field">
          <select v-model="editar.tipster_landing_servicio_id" class="ls-select ls-select--full" :disabled="cargandoPersonalizacionesEditar">
            <option value="">{{ cargandoPersonalizacionesEditar ? 'Cargando...' : '— Sin personalización —' }}</option>
            <option v-for="p in personalizacionesEditar" :key="p.id" :value="p.id">{{ p.nombre }} ({{ p.idioma }})</option>
          </select>
        </div>

        <!-- Precio -->
        <div class="ls-section-label mt-3">Precio</div>
        <div class="ls-toggle-row">
          <label class="ls-toggle-label">
            <input type="checkbox" v-model="editar.mostrar_precio" class="ls-toggle-input" />
            <span class="ls-toggle-track"><span class="ls-toggle-thumb"></span></span>
            Mostrar precio en la landing
          </label>
        </div>
        <div v-if="editar.mostrar_precio && editarTarget" class="ls-precio-panel">
          <div v-if="editarTarget.precio_rebajado" class="ls-precio-preview">
            Se mostrará: <s class="opacity-5">{{ editarTarget.precio_rebajado }}</s>
          </div>
          <div v-else class="ls-precio-preview">Se mostrará el precio del servicio</div>
          <div v-if="editarTarget.tipo_venta !== 'venta_unica' && editarTarget.dias_gracia > 0" class="ls-gratis-badge">
            <i class="fa fa-gift me-1"></i> Se mostrarán <strong>{{ editarTarget.dias_gracia }} días gratis</strong> automáticamente
          </div>
        </div>

        <div v-if="errorEditar" class="ls-alert ls-alert--err mt-3">{{ errorEditar }}</div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn-secondary" @click="modalEditar=false">Cancelar</button>
        <button class="btn-ls-primary" :disabled="editando" @click="guardarEdicion()">
          <i v-if="editando" class="fa fa-spinner fa-spin me-1"></i>
          {{ editando ? 'Guardando...' : 'Guardar cambios' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal: Confirmar borrar -->
  <div v-if="modalBorrar" class="modal-overlay" @click.self="modalBorrar=false">
    <div class="ls-modal ls-modal--sm">
      <div class="ls-modal-header">
        <span>Eliminar landing</span>
        <button class="det-close" @click="modalBorrar=false">✕</button>
      </div>
      <div class="ls-modal-body">
        <p>¿Eliminar la landing de <strong>{{ borrarTarget?.producto_nombre }}</strong>?</p>
        <p class="opacity-6 small">Esta acción es irreversible. La URL pública dejará de funcionar.</p>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn-secondary" @click="modalBorrar=false">Cancelar</button>
        <button class="btn-ls-danger" :disabled="procesando===borrarTarget?.id" @click="borrar()">Eliminar</button>
      </div>
    </div>
  </div>

  <!-- Modal: Vista previa -->
  <div v-if="modalPrevia" class="overlay" @click.self="modalPrevia=false">
    <div class="ls-preview-box">
      <div class="ls-preview-header">
        <span class="ls-preview-title"><i class="fa fa-mobile-alt me-1"></i> Vista previa móvil</span>
        <button class="ls-preview-close" @click="modalPrevia=false"><i class="fa fa-times"></i></button>
      </div>
      <div class="ls-preview-phone">
        <div v-if="cargandoPrevia" class="ls-preview-loading"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
        <iframe v-else-if="previaHtml" :srcdoc="previaHtml" class="ls-preview-iframe" frameborder="0" sandbox="allow-scripts allow-same-origin"></iframe>
      </div>
      <div class="ls-preview-footer">
        <button class="ls-btn-secondary" @click="modalPrevia=false">Cerrar</button>
        <button class="ls-btn-secondary" @click="abrirEnNuevaPestana()">Abrir en nueva pestaña</button>
      </div>
    </div>
  </div>

  <!-- Modal: Editor de bloques -->
  <div v-if="modalBloques" class="modal-overlay" @click.self="modalBloques=false">
    <div class="ls-modal ls-modal--bloques">
      <div class="ls-modal-header">
        <span><i class="fa fa-th-large me-2 text-gold"></i>{{ bloquesMode === 'editar' ? 'Editar bloques — ' + editarTarget?.producto_nombre : 'Contenido de la landing' }}</span>
        <button class="det-close" @click="modalBloques=false">✕</button>
      </div>
      <div ref="bloquesBody" class="ls-modal-body ls-bloques-body">

        <!-- Lista de bloques -->
        <div v-if="bloquesWip.length === 0" class="ls-bloques-empty">
          <i class="fa fa-plus-circle fa-2x mb-2 opacity-4"></i>
          <p class="opacity-5 small mb-0">Añade bloques para construir el contenido de la landing</p>
        </div>

        <div v-for="(b, idx) in bloquesWip" :key="idx" class="ls-bloque-card">
          <!-- Cabecera del bloque -->
          <div class="ls-bloque-head" @click="bloqueExpandido = bloqueExpandido === idx ? null : idx">
            <i :class="'fa ' + iconTipo(b.tipo) + ' ls-bloque-icon'"></i>
            <span class="ls-bloque-label">{{ labelTipo(b.tipo) }}</span>
            <span class="ls-bloque-preview">{{ b.tipo === 'hero' ? b.titulo : b.tipo === 'texto' ? b.texto : b.tipo === 'boton_cta' ? b.texto : b.tipo === 'resenas' ? b.titulo : (b.items && b.items[0] ? b.items[0].pregunta : '') }}</span>
            <div class="ls-bloque-actions">
              <button type="button" class="ls-blk-btn" title="Subir" :disabled="idx===0" @click.stop="moverBloque(idx,-1)"><i class="fa fa-chevron-up"></i></button>
              <button type="button" class="ls-blk-btn" title="Bajar" :disabled="idx===bloquesWip.length-1" @click.stop="moverBloque(idx,1)"><i class="fa fa-chevron-down"></i></button>
              <button type="button" class="ls-blk-btn ls-blk-btn--del" title="Eliminar" @click.stop="eliminarBloque(idx)"><i class="fa fa-trash"></i></button>
              <i :class="'fa fa-chevron-' + (bloqueExpandido===idx ? 'up' : 'down') + ' ms-1 opacity-4'"></i>
            </div>
          </div>

          <!-- Campos del bloque (expandido) -->
          <div v-if="bloqueExpandido === idx" class="ls-bloque-fields">

            <!-- HERO -->
            <template v-if="b.tipo === 'hero'">
              <div class="ls-form-field">
                <label>Título principal</label>
                <input v-model="b.titulo" class="ls-input" placeholder="I'm Santi, the best Spanish tipster" />
              </div>
              <div class="ls-form-field">
                <label>Subtítulo</label>
                <input v-model="b.subtitulo" class="ls-input" placeholder="87% accuracy verified · +10 years experience" />
              </div>
              <div class="ls-form-field">
                <label>Descripción</label>
                <textarea v-model="b.descripcion" class="ls-input ls-textarea" rows="4" placeholder="I'm so confident in my results that I give a free week to new subscribers..."></textarea>
              </div>
              <div class="ls-form-field">
                <label>Credenciales <span class="ls-hint">(una por línea)</span></label>
                <textarea v-model="b.credenciales" class="ls-input ls-textarea" rows="3" placeholder="87% accuracy verified&#10;+10 years of experience&#10;Most subscribers in Spain"></textarea>
              </div>
              <div class="ls-form-field ls-form-field--inline">
                <label class="ls-check-label">
                  <input type="checkbox" v-model="b.credenciales_ticket" class="ls-check" />
                  Mostrar ✓ delante de cada credencial
                </label>
              </div>
            </template>

            <!-- TEXTO -->
            <template v-else-if="b.tipo === 'texto'">
              <div class="ls-form-field">
                <label>Texto</label>
                <textarea v-model="b.texto" class="ls-input ls-textarea" rows="5" placeholder="Escribe el contenido de esta sección..."></textarea>
              </div>
            </template>

            <!-- CTA BUTTON -->
            <template v-else-if="b.tipo === 'boton_cta'">
              <div class="ls-form-field">
                <label>Texto del botón</label>
                <input v-model="b.texto" class="ls-input" placeholder="Free Trial $0.00 · 7 days" />
              </div>
              <div class="ls-form-field">
                <label>Badge de urgencia <span class="ls-hint">(encima del botón)</span></label>
                <input v-model="b.badge" class="ls-input" placeholder="⚡ Limited spots" />
              </div>
              <div class="ls-form-field">
                <label>Texto de confianza <span class="ls-hint">(debajo del botón)</span></label>
                <input v-model="b.trust" class="ls-input" placeholder="🔒 Secure · No commitment · Cancel anytime" />
              </div>
            </template>

            <!-- RESEÑAS -->
            <template v-else-if="b.tipo === 'resenas'">
              <div class="ls-form-field">
                <label>Título de sección</label>
                <input v-model="b.titulo" class="ls-input" placeholder="What my subscribers say" />
              </div>
              <!-- Capturas: solo disponible en modo edición (landing ya existe) -->
              <template v-if="bloquesMode === 'editar' && editarTarget">
                <div class="ls-capturas-label">
                  Capturas de pantalla
                  <span class="ls-hint">(screenshots de Telegram, WhatsApp, etc.)</span>
                </div>
                <!-- Grid de capturas existentes -->
                <div v-if="b.capturas && b.capturas.length" class="ls-capturas-grid">
                  <div v-for="(c, ci) in b.capturas" :key="ci" class="ls-captura-item">
                    <img :src="c.url" class="ls-captura-img" />
                    <button type="button" class="ls-captura-del" @click="eliminarCaptura(b, ci, c)" :disabled="c._deleting">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <!-- Botón subir -->
                <label class="ls-btn-upload" :class="{ 'ls-btn-upload--loading': b._uploading }">
                  <input type="file" accept="image/jpeg,image/png,image/webp" @change="subirCaptura($event, b)" :disabled="b._uploading" style="display:none" multiple />
                  <i v-if="b._uploading" class="fa fa-spinner fa-spin me-1"></i>
                  <i v-else class="fa fa-camera me-1"></i>
                  {{ b._uploading ? `Subiendo ${b._uploadProgress || ''}...` : 'Añadir capturas' }}
                </label>
                <p v-if="b._errorUpload" class="ls-alert ls-alert--err mt-2">{{ b._errorUpload }}</p>
              </template>
              <p v-else class="ls-hint opacity-6">Las capturas se pueden subir al editar la landing (después de crearla).</p>
            </template>

            <!-- IMÁGENES -->
            <template v-else-if="b.tipo === 'imagen'">
              <div class="ls-capturas-label">
                Imágenes del bloque
                <span class="ls-hint">(banners, fotos, gráficos…)</span>
              </div>
              <template v-if="bloquesMode === 'editar' && editarTarget">
                <!-- Grid de imágenes existentes -->
                <div v-if="b.items && b.items.length" class="ls-capturas-grid ls-capturas-grid--imagen">
                  <div v-for="(img, ii) in b.items" :key="ii" class="ls-captura-item ls-captura-item--imagen">
                    <img :src="img.url" class="ls-captura-img ls-captura-img--fit" />
                    <button type="button" class="ls-captura-del" @click="eliminarImagenBloque(b, ii, img)" :disabled="img._deleting">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <!-- Caption opcional para cada imagen -->
                <template v-if="b.items && b.items.length">
                  <div v-for="(img, ii) in b.items" :key="'cap-' + ii" class="ls-form-field mb-1">
                    <label class="ls-caption-label">Pie foto {{ ii + 1 }} <span class="ls-hint">(opcional)</span></label>
                    <input v-model="img.caption" class="ls-input" placeholder="Descripción de la imagen..." />
                  </div>
                </template>
                <!-- Botón subir -->
                <label class="ls-btn-upload" :class="{ 'ls-btn-upload--loading': b._uploading }">
                  <input type="file" accept="image/jpeg,image/png,image/webp" @change="subirImagenBloque($event, b)" :disabled="b._uploading" style="display:none" multiple />
                  <i v-if="b._uploading" class="fa fa-spinner fa-spin me-1"></i>
                  <i v-else class="fa fa-image me-1"></i>
                  {{ b._uploading ? 'Subiendo...' : 'Añadir imagen' }}
                </label>
                <p v-if="b._errorUpload" class="ls-alert ls-alert--err mt-2">{{ b._errorUpload }}</p>
              </template>
              <p v-else class="ls-hint opacity-6">Las imágenes se pueden subir al editar la landing (después de crearla).</p>
            </template>

            <!-- FAQ -->
            <template v-else-if="b.tipo === 'faq'">
              <div class="ls-faq-scroll" :ref="'faqScroll' + idx">
                <div v-for="(item, i) in b.items" :key="i" class="ls-faq-item">
                  <div class="ls-faq-item-head">
                    <span class="ls-faq-num">Q{{ i + 1 }}</span>
                    <button type="button" class="ls-blk-btn ls-blk-btn--del" @click="eliminarFaqItem(b, i)" :disabled="b.items.length === 1"><i class="fa fa-times"></i></button>
                  </div>
                  <input v-model="item.pregunta" class="ls-input mb-1" placeholder="¿Pregunta frecuente?" />
                  <textarea v-model="item.respuesta" class="ls-input ls-textarea" rows="3" placeholder="Respuesta detallada..."></textarea>
                </div>
              </div>
              <button type="button" class="ls-btn-add-faq" @click="agregarFaqItem(b, idx)"><i class="fa fa-plus me-1"></i>Añadir pregunta</button>
            </template>

            <!-- VS -->
            <template v-else-if="b.tipo === 'vs'">
              <div class="ls-vs-grid">
                <!-- Equipo 1 -->
                <div class="ls-vs-slot">
                  <div class="ls-vs-slot-label">Equipo local</div>
                  <div class="ls-vs-img-preview" v-if="b.equipo1 && b.equipo1.url">
                    <img :src="b.equipo1.url" class="ls-vs-thumb" />
                    <button type="button" class="ls-captura-del" @click="eliminarImagenVs(b, 'equipo1')" :disabled="b.equipo1._deleting"><i class="fa fa-times"></i></button>
                  </div>
                  <template v-else-if="bloquesMode === 'editar' && editarTarget">
                    <label class="ls-btn-upload" :class="{ 'ls-btn-upload--loading': b._uploading1 }">
                      <input type="file" accept="image/jpeg,image/png,image/webp" @change="subirImagenVs($event, b, 'equipo1')" :disabled="b._uploading1" style="display:none" />
                      <i v-if="b._uploading1" class="fa fa-spinner fa-spin me-1"></i>
                      <i v-else class="fa fa-upload me-1"></i>
                      {{ b._uploading1 ? 'Subiendo...' : 'Subir escudo' }}
                    </label>
                  </template>
                  <p v-else class="ls-hint opacity-6">Disponible al editar.</p>
                  <input v-model="b.nombre1" class="ls-input mt-2" placeholder="Nombre equipo 1" />
                </div>
                <!-- Equipo 2 -->
                <div class="ls-vs-slot">
                  <div class="ls-vs-slot-label">Equipo visitante</div>
                  <div class="ls-vs-img-preview" v-if="b.equipo2 && b.equipo2.url">
                    <img :src="b.equipo2.url" class="ls-vs-thumb" />
                    <button type="button" class="ls-captura-del" @click="eliminarImagenVs(b, 'equipo2')" :disabled="b.equipo2._deleting"><i class="fa fa-times"></i></button>
                  </div>
                  <template v-else-if="bloquesMode === 'editar' && editarTarget">
                    <label class="ls-btn-upload" :class="{ 'ls-btn-upload--loading': b._uploading2 }">
                      <input type="file" accept="image/jpeg,image/png,image/webp" @change="subirImagenVs($event, b, 'equipo2')" :disabled="b._uploading2" style="display:none" />
                      <i v-if="b._uploading2" class="fa fa-spinner fa-spin me-1"></i>
                      <i v-else class="fa fa-upload me-1"></i>
                      {{ b._uploading2 ? 'Subiendo...' : 'Subir escudo' }}
                    </label>
                  </template>
                  <p v-else class="ls-hint opacity-6">Disponible al editar.</p>
                  <input v-model="b.nombre2" class="ls-input mt-2" placeholder="Nombre equipo 2" />
                </div>
              </div>
              <p v-if="b._errorUpload" class="ls-alert ls-alert--err mt-2">{{ b._errorUpload }}</p>
            </template>

            <!-- COUNTDOWN -->
            <template v-else-if="b.tipo === 'countdown'">
              <div class="ls-form-field">
                <label>Título <span class="ls-hint">(encima del contador)</span></label>
                <input v-model="b.titulo" class="ls-input" placeholder="El partido empieza en / Match starts in" />
              </div>
              <div class="ls-form-field">
                <label>Fecha y hora del partido</label>
                <input v-model="b.fecha" type="datetime-local" class="ls-input" />
              </div>
            </template>

            <template v-else-if="b.tipo === 'timer'">
              <div class="ls-form-field">
                <label>Título <span class="ls-hint">(opcional, encima del timer)</span></label>
                <input v-model="b.titulo" class="ls-input" placeholder="⚡ Oferta por tiempo limitado" />
              </div>
              <div class="ls-form-field">
                <label>Minutos <span class="ls-hint">(1–120, desde que carga la página)</span></label>
                <input v-model.number="b.minutos" type="number" min="1" max="120" class="ls-input" style="max-width:100px" />
              </div>
              <div class="ls-form-field">
                <label>Texto al expirar <span class="ls-hint">(opcional)</span></label>
                <input v-model="b.texto_fin" class="ls-input" placeholder="⏰ Oferta expirada" />
              </div>
            </template>

          </div>
        </div>

        <!-- Añadir bloque -->
        <div class="ls-add-bloque-wrap">
          <button type="button" class="ls-btn-add-bloque" @click="mostrarMenuTipo = !mostrarMenuTipo">
            <i class="fa fa-plus me-1"></i>Añadir bloque
          </button>
          <div v-if="mostrarMenuTipo" class="ls-tipo-menu">
            <button v-for="t in tiposBloques" :key="t.tipo" type="button" class="ls-tipo-item" @click="agregarBloque(t.tipo)">
              <i :class="'fa ' + t.icon + ' me-2'"></i>{{ t.label }}
            </button>
          </div>
        </div>

      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn-secondary" @click="modalBloques=false">Cancelar</button>
        <button class="btn-ls-primary" @click="guardarBloques()">
          <i class="fa fa-check me-1"></i>Guardar contenido
        </button>
      </div>
    </div>
  </div>

  <!-- Modal Meta Ads -->
  <ModalMetaCampana
    :modalActive="modalMetaActive"
    :productoLandingId="metaLanding?.id || 0"
    :landingNombre="metaLanding?.producto_nombre || ''"
    :tipsterNombre="metaLanding?.tipster_nombre || ''"
    @cerrar-modal="modalMetaActive = false"
    @campaña-creada="onCampanaCreada"
  />

  <!-- Toast -->
  <div v-if="toast" class="ls-toast" :class="toast.tipo === 'ok' ? 'ls-toast--ok' : 'ls-toast--err'">
    {{ toast.msg }}
  </div>
</template>

<script>
import api from "@/services/apiClient.js";
import ModalMetaCampana from "./components/ModalMetaCampana.vue";

export default {
  name: "LandingServicios",
  components: { ModalMetaCampana },
  data() {
    return {
      cargando: false,
      error: null,
      landings: [],
      tipsters: [],
      filtroTipster: "",
      filtroEstado: "",
      paginaActual: 1,
      totalPaginas: 1,
      procesando: null,

      // Modal crear
      modalCrear: false,
      servicios: [],
      personalizaciones: [],
      cargandoServicios: false,
      cargandoPersonalizaciones: false,
      creando: false,
      errorCrear: null,
      crear: { tipster_id: "", producto_id: "", tipster_landing_servicio_id: "", mostrar_precio: false, bloques: [] },

      // Modal bloques
      modalBloques: false,
      bloquesWip: [],
      bloqueExpandido: null,
      mostrarMenuTipo: false,
      tiposBloques: [
        { tipo: 'hero',      label: 'Héroe / Intro',      icon: 'fa-star' },
        { tipo: 'texto',     label: 'Texto',              icon: 'fa-align-left' },
        { tipo: 'boton_cta', label: 'Botón CTA',          icon: 'fa-mouse-pointer' },
        { tipo: 'resenas',   label: 'Reseñas / Testimonios', icon: 'fa-comment-dots' },
        { tipo: 'imagen',    label: 'Imágenes',            icon: 'fa-image' },
        { tipo: 'faq',       label: 'FAQ',                icon: 'fa-question-circle' },
        { tipo: 'vs',        label: 'VS (equipos)',        icon: 'fa-shield' },
        { tipo: 'countdown', label: 'Cuenta atrás',        icon: 'fa-clock-o' },
        { tipo: 'timer',     label: 'Timer urgencia',      icon: 'fa-hourglass-half' },
      ],

      // Modal editar
      modalEditar: false,
      editarTarget: null,
      personalizacionesEditar: [],
      cargandoPersonalizacionesEditar: false,
      serviciosEditar: [],
      cargandoServiciosEditar: false,
      editando: false,
      errorEditar: null,
      editar: { producto_id: "", tipster_landing_servicio_id: "", mostrar_precio: false, bloques: [] },

      // Modo del editor de bloques: 'crear' | 'editar'
      bloquesMode: 'crear',

      // Modal borrar
      modalBorrar: false,
      borrarTarget: null,

      // Modal previa
      modalPrevia: false,
      previaLanding: null,
      previaHtml: null,
      cargandoPrevia: false,

      toast: null,

      // Modal Meta
      modalMetaActive: false,
      metaLanding: null,
    };
  },
  computed: {
    permisos()        { return this.$store.getters['auth/permisos'] || []; },
    puedeCampanaMeta(){ return this.permisos.includes('meta.crear_campana'); },
    servicioSeleccionado() {
      if (!this.crear.producto_id) return null;
      return this.servicios.find(s => s.id == this.crear.producto_id) || null;
    },
    puedeCrear() {
      return this.crear.tipster_id && this.crear.producto_id && this.crear.bloques.length > 0;
    },
  },
  async mounted() {
    await Promise.all([this.cargarTipsters(), this.cargar()]);
  },
  methods: {
    async cargarTipsters() {
      try {
        const { data } = await api.post("/api/v2/tipster-landing-servicio/listar");
        this.tipsters = (data.tipsters || []).map((t) => ({ id: t.tipster_id, nombre: t.tipster_nombre }));
      } catch (e) { /* silencioso */ }
    },

    async cargar() {
      this.cargando = true;
      this.error = null;
      try {
        const { data } = await api.post("/api/v2/producto-landing/listar", {
          tipster_id: this.filtroTipster || undefined,
          estado: this.filtroEstado || undefined,
          page: this.paginaActual,
        });
        this.landings = data.landings || [];
        this.totalPaginas = data.paginas || 1;
      } catch (e) {
        this.error = e?.response?.data?.message || "Error al cargar las landings.";
      } finally {
        this.cargando = false;
      }
    },

    abrirCrear() {
      this.crear = { tipster_id: "", producto_id: "", tipster_landing_servicio_id: "", mostrar_precio: false, bloques: [] };
      this.servicios = [];
      this.personalizaciones = [];
      this.errorCrear = null;
      this.modalCrear = true;
    },

    // ── Editor de bloques ───────────────────────────────────────────
    abrirBloques(mode = 'crear') {
      this.bloquesMode = mode;
      const source = mode === 'editar' ? this.editar.bloques : this.crear.bloques;
      this.bloquesWip = JSON.parse(JSON.stringify(source));
      this.bloqueExpandido = null;
      this.mostrarMenuTipo = false;
      this.modalBloques = true;
    },
    guardarBloques() {
      const bloques = JSON.parse(JSON.stringify(this.bloquesWip));
      if (this.bloquesMode === 'editar') {
        this.editar.bloques = bloques;
      } else {
        this.crear.bloques = bloques;
      }
      this.modalBloques = false;
    },
    agregarBloque(tipo) {
      const base = {
        hero:      { tipo: 'hero',      titulo: '', subtitulo: '', descripcion: '', credenciales: '', credenciales_ticket: true },
        texto:     { tipo: 'texto',     texto: '' },
        boton_cta: { tipo: 'boton_cta', texto: 'Free Trial $0.00 · 7 days', badge: '⚡ Limited spots', trust: '🔒 Secure · No commitment · Cancel anytime' },
        resenas:   { tipo: 'resenas',   titulo: 'What my subscribers say', capturas: [] },
        imagen:    { tipo: 'imagen',    items: [] },
        faq:       { tipo: 'faq',       items: [{ pregunta: '', respuesta: '' }] },
        vs:        { tipo: 'vs',        nombre1: '', nombre2: '', equipo1: null, equipo2: null },
        countdown: { tipo: 'countdown', titulo: '', fecha: '' },
        timer:     { tipo: 'timer',     titulo: '', minutos: 23, texto_fin: '' },
      }[tipo];
      this.bloquesWip.push({ ...base });
      this.bloqueExpandido = this.bloquesWip.length - 1;
      this.mostrarMenuTipo = false;
      this.$nextTick(() => {
        const body = this.$refs.bloquesBody;
        if (body) body.scrollTop = body.scrollHeight;
      });
    },
    eliminarBloque(idx) {
      this.bloquesWip.splice(idx, 1);
      if (this.bloqueExpandido === idx) this.bloqueExpandido = null;
    },
    moverBloque(idx, dir) {
      const arr = this.bloquesWip;
      const to = idx + dir;
      if (to < 0 || to >= arr.length) return;
      [arr[idx], arr[to]] = [arr[to], arr[idx]];
      this.bloqueExpandido = to;
    },
    agregarFaqItem(bloque, idx) {
      bloque.items.push({ pregunta: '', respuesta: '' });
      this.$nextTick(() => {
        const scroll = this.$refs['faqScroll' + idx];
        const el = Array.isArray(scroll) ? scroll[0] : scroll;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    eliminarFaqItem(bloque, i) {
      bloque.items.splice(i, 1);
    },

    async subirCaptura(event, bloque) {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;
      event.target.value = '';
      bloque._uploading = true;
      bloque._errorUpload = null;
      if (!bloque.capturas) bloque.capturas = [];
      const errores = [];
      for (let i = 0; i < files.length; i++) {
        bloque._uploadProgress = files.length > 1 ? `${i + 1}/${files.length}` : '';
        const form = new FormData();
        form.append('landing_id', this.editarTarget.id);
        form.append('imagen', files[i]);
        try {
          const { data } = await api.post('/api/v2/producto-landing/subir-captura', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          bloque.capturas.push({ url: data.url, path: data.path });
        } catch (e) {
          errores.push(`Imagen ${i + 1}: ${e?.response?.data?.message || 'Error al subir.'}`);
        }
      }
      bloque._uploadProgress = '';
      bloque._uploading = false;
      bloque._errorUpload = errores.length ? errores.join(' | ') : null;
    },

    async eliminarCaptura(bloque, idx, captura) {
      try {
        captura._deleting = true;
        await api.post('/api/v2/producto-landing/eliminar-captura', {
          landing_id: this.editarTarget.id,
          path: captura.path,
        });
        bloque.capturas.splice(idx, 1);
      } catch (e) {
        // eslint-disable-next-line require-atomic-updates
        captura._deleting = false;
      }
    },

    async subirImagenBloque(event, bloque) {
      const files = Array.from(event.target.files || []);
      if (!files.length) return;
      event.target.value = '';
      bloque._uploading = true;
      bloque._errorUpload = null;
      if (!bloque.items) bloque.items = [];
      try {
        for (const file of files) {
          const form = new FormData();
          form.append('landing_id', this.editarTarget.id);
          form.append('imagen', file);
          const { data } = await api.post('/api/v2/producto-landing/subir-imagen-bloque', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          bloque.items.push({ url: data.url, path: data.path, caption: '' });
        }
      } catch (e) {
        bloque._errorUpload = e?.response?.data?.message || 'Error al subir la imagen.';
      } finally {
        bloque._uploading = false;
      }
    },

    async eliminarImagenBloque(bloque, idx, img) {
      try {
        img._deleting = true;
        await api.post('/api/v2/producto-landing/eliminar-captura', {
          landing_id: this.editarTarget.id,
          path: img.path,
        });
        bloque.items.splice(idx, 1);
      } catch (e) {
        // eslint-disable-next-line require-atomic-updates
        img._deleting = false;
      }
    },
    async subirImagenVs(event, bloque, slot) {
      const file = event.target.files?.[0];
      if (!file) return;
      event.target.value = '';
      const loadingKey = slot === 'equipo1' ? '_uploading1' : '_uploading2';
      bloque[loadingKey] = true;
      bloque._errorUpload = null;
      try {
        const form = new FormData();
        form.append('landing_id', this.editarTarget.id);
        form.append('imagen', file);
        const { data } = await api.post('/api/v2/producto-landing/subir-imagen-bloque', form, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        bloque[slot] = { url: data.url, path: data.path };
      } catch (e) {
        bloque._errorUpload = e?.response?.data?.message || 'Error al subir la imagen.';
      } finally {
        bloque[loadingKey] = false;
      }
    },

    async eliminarImagenVs(bloque, slot) {
      const img = bloque[slot];
      if (!img) return;
      try {
        img._deleting = true;
        await api.post('/api/v2/producto-landing/eliminar-captura', {
          landing_id: this.editarTarget.id,
          path: img.path,
        });
        // eslint-disable-next-line require-atomic-updates
        bloque[slot] = null;
      } catch (e) {
        // eslint-disable-next-line require-atomic-updates
        img._deleting = false;
      }
    },

    labelTipo(tipo) {
      return { hero: 'Héroe / Intro', texto: 'Texto', boton_cta: 'Botón CTA', resenas: 'Reseñas', imagen: 'Imágenes', faq: 'FAQ', vs: 'VS (equipos)', countdown: 'Cuenta atrás', timer: 'Timer urgencia' }[tipo] || tipo;
    },
    iconTipo(tipo) {
      return { hero: 'fa-star', texto: 'fa-align-left', boton_cta: 'fa-mouse-pointer', resenas: 'fa-comment-dots', faq: 'fa-question-circle', vs: 'fa-shield', countdown: 'fa-clock-o', timer: 'fa-hourglass-half' }[tipo] || 'fa-cube';
    },

    onSeleccionarServicio() {},

    async cargarServicios() {
      if (!this.crear.tipster_id) return;
      this.crear.producto_id = "";
      this.cargandoServicios = true;
      try {
        const { data } = await api.post("/api/v2/producto-landing/servicios-tipster", { tipster_id: this.crear.tipster_id });
        this.servicios = data.productos || [];
      } catch (e) { /* silencioso */ } finally {
        this.cargandoServicios = false;
      }
    },

    async cargarPersonalizaciones() {
      if (!this.crear.tipster_id) return;
      this.crear.tipster_landing_servicio_id = "";
      this.cargandoPersonalizaciones = true;
      try {
        const { data } = await api.post("/api/v2/tipster-landing-servicio/listar");
        const grupo = (data.tipsters || []).find((t) => t.tipster_id == this.crear.tipster_id);
        this.personalizaciones = grupo?.personalizaciones || [];
      } catch (e) { /* silencioso */ } finally {
        this.cargandoPersonalizaciones = false;
      }
    },

    async crearLanding() {
      this.errorCrear = null;
      this.creando = true;
      try {
        const { data } = await api.post("/api/v2/producto-landing/crear", {
          tipster_id: this.crear.tipster_id,
          producto_id: this.crear.producto_id,
          tipster_landing_servicio_id: this.crear.tipster_landing_servicio_id || null,
          mostrar_precio: this.crear.mostrar_precio,
          bloques: this.crear.bloques.length ? this.crear.bloques : null,
        });
        this.modalCrear = false;
        this.landings.unshift(data.landing);
        this.showToast("Landing creada en borrador.", "ok");
      } catch (e) {
        this.errorCrear = e?.response?.data?.message || "Error al crear la landing.";
      } finally {
        this.creando = false;
      }
    },

    async abrirEditar(l) {
      this.editarTarget = l;
      this.errorEditar = null;
      this.editar = {
        producto_id: l.producto_id || "",
        tipster_landing_servicio_id: l.tipster_landing_servicio_id || "",
        cta_link: l.cta_link || "",
        mostrar_precio: !!l.mostrar_precio,
        bloques: JSON.parse(JSON.stringify(l.bloques || [])),
      };
      this.personalizacionesEditar = [];
      this.serviciosEditar = [];
      this.cargandoPersonalizacionesEditar = true;
      this.cargandoServiciosEditar = true;
      this.modalEditar = true;
      try {
        const [tlsRes, srvRes] = await Promise.all([
          api.post("/api/v2/tipster-landing-servicio/listar"),
          api.post("/api/v2/producto-landing/servicios-tipster", { tipster_id: l.tipster_id }),
        ]);
        const grupo = (tlsRes.data.tipsters || []).find((t) => t.tipster_id == l.tipster_id);
        this.personalizacionesEditar = grupo?.personalizaciones || [];
        this.serviciosEditar = srvRes.data.productos || [];
      } catch (e) { /* silencioso */ } finally {
        this.cargandoPersonalizacionesEditar = false;
        this.cargandoServiciosEditar = false;
      }
    },

    async guardarEdicion() {
      this.errorEditar = null;
      this.editando = true;
      try {
        const { data } = await api.post("/api/v2/producto-landing/guardar", {
          landing_id: this.editarTarget.id,
          producto_id: this.editar.producto_id || null,
          tipster_landing_servicio_id: this.editar.tipster_landing_servicio_id || null,
          cta_link: this.editar.cta_link || null,
          mostrar_precio: this.editar.mostrar_precio,
          bloques: this.editar.bloques,
        });
        // Actualizar la fila en la tabla
        const idx = this.landings.findIndex((x) => x.id === this.editarTarget.id);
        if (idx !== -1) this.landings.splice(idx, 1, data.landing);
        this.modalEditar = false;
        this.showToast("Landing actualizada.", "ok");
      } catch (e) {
        this.errorEditar = e?.response?.data?.message || "Error al guardar.";
      } finally {
        this.editando = false;
      }
    },

    async publicar(l) {
      this.procesando = l.id;
      try {
        const { data } = await api.post("/api/v2/producto-landing/publicar", { landing_id: l.id });
        const idx = this.landings.findIndex((x) => x.id === l.id);
        if (idx !== -1) this.landings[idx] = data.landing;
        this.showToast("Landing publicada.", "ok");
      } catch (e) {
        this.showToast(e?.response?.data?.message || "Error.", "err");
      } finally {
        this.procesando = null;
      }
    },

    async pausar(l) {
      this.procesando = l.id;
      try {
        const { data } = await api.post("/api/v2/producto-landing/pausar", { landing_id: l.id });
        const idx = this.landings.findIndex((x) => x.id === l.id);
        if (idx !== -1) this.landings[idx] = data.landing;
        this.showToast("Landing pausada.", "ok");
      } catch (e) {
        this.showToast(e?.response?.data?.message || "Error.", "err");
      } finally {
        this.procesando = null;
      }
    },

    confirmarBorrar(l) {
      this.borrarTarget = l;
      this.modalBorrar = true;
    },

    async borrar() {
      this.procesando = this.borrarTarget.id;
      try {
        await api.post("/api/v2/producto-landing/borrar", { landing_id: this.borrarTarget.id });
        this.landings = this.landings.filter((x) => x.id !== this.borrarTarget.id);
        this.modalBorrar = false;
        this.showToast("Landing eliminada.", "ok");
      } catch (e) {
        this.showToast(e?.response?.data?.message || "Error.", "err");
      } finally {
        this.procesando = null;
      }
    },

    async verPrevia(l) {
      this.previaLanding = l;
      this.previaHtml = null;
      this.modalPrevia = true;
      this.cargandoPrevia = true;
      try {
        const { data } = await api.post("/api/v2/producto-landing/vista-previa", { landing_id: l.id }, { responseType: "text" });
        this.previaHtml = data;
      } catch {
        this.previaHtml = "<p style='color:red;padding:2rem'>Error al cargar la vista previa.</p>";
      } finally {
        this.cargandoPrevia = false;
      }
    },

    abrirEnNuevaPestana() {
      if (!this.previaHtml) return;
      const blob = new Blob([this.previaHtml], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    },

    copiarUrl(url) {
      navigator.clipboard.writeText(url).then(() => this.showToast("URL copiada.", "ok")).catch(() => {});
    },

    claseEstado(e) {
      return { borrador: "ls-badge--borrador", publicada: "ls-badge--publicada", pausada: "ls-badge--pausada" }[e] || "";
    },

    showToast(msg, tipo = "ok") {
      this.toast = { msg, tipo };
      setTimeout(() => (this.toast = null), 3000);
    },

    abrirMeta(l) {
      this.metaLanding    = l;
      this.modalMetaActive = true;
    },

    onCampanaCreada(d) {
      const l = this.landings.find(x => x.id === this.metaLanding?.id);
      if (l) l.meta_campaign_id = d.meta_campaign_id;
      this.modalMetaActive = false;
    },
  },
};
</script>

<style scoped>
.ls-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.ls-toolbar-left {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.ls-select {
  background: var(--q-card, #1a2332);
  color: var(--q-text, #c8d6e5);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 0.4rem;
  padding: 0.35rem 0.65rem;
  font-size: 0.82rem;
}
.ls-select--full { width: 100%; }
.btn-ls-primary {
  background: var(--q-gold, #f5a623);
  color: #000;
  border: none;
  border-radius: 0.45rem;
  padding: 0.4rem 1rem;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}
.btn-ls-primary:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-ls-danger {
  background: #dc3545;
  color: #fff;
  border: none;
  border-radius: 0.45rem;
  padding: 0.4rem 1rem;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}
.ls-btn-secondary {
  background: rgba(255,255,255,0.07);
  color: var(--q-text, #c8d6e5);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 0.4rem;
  padding: 0.38rem 0.85rem;
  font-size: 0.82rem;
  cursor: pointer;
}
.ls-table-wrap { overflow-x: auto; }
/* Badges idioma/estado — mismo estilo que Landings */
.lnd-badge {
  display: inline-block;
  font-size: .68rem; font-weight: 700;
  letter-spacing: .05em; border-radius: 4px; padding: 2px 7px;
}
.lnd-badge--idioma { background: rgba(160,100,255,.12); color: #c084fc; letter-spacing: .03em; }
.lnd-estado {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: .68rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: .04em; border-radius: 4px; padding: 2px 7px;
  white-space: nowrap;
}
.lnd-estado--publicada { background: rgba(0,230,118,.12); color: #00e676; }
.lnd-estado--borrador  { background: rgba(160,160,160,.1); color: var(--q-muted); }
.lnd-estado--pausada   { background: rgba(255,180,0,.12); color: #ffb400; }
.lnd-acciones { white-space: nowrap; }
.ls-url-cell { display: flex; align-items: center; gap: 5px; }
.ls-url-text {
  font-size: 0.72rem; opacity: 0.65;
  max-width: 100px; overflow: hidden;
  text-overflow: ellipsis; white-space: nowrap;
}
.ls-pag { display: flex; align-items: center; gap: 0.5rem; justify-content: center; }
.ls-pag-btn {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  color: var(--q-text, #c8d6e5);
  border-radius: 0.35rem; padding: 0.25rem 0.6rem; cursor: pointer;
}
.ls-pag-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.ls-pag-info { font-size: 0.8rem; opacity: 0.7; }

/* Modales */
.modal-overlay {
  position: fixed; inset: 0; z-index: 1060;
  background: rgba(0,0,0,0.6);
  display: flex; align-items: center; justify-content: center;
  padding: 1rem;
}
.ls-modal {
  background: var(--q-card, #1a2332);
  color: var(--q-text, #c8d6e5);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 0.85rem;
  width: 100%;
  max-width: 480px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0,0,0,0.55);
}
.ls-modal--sm { max-width: 360px; }
.ls-modal--previa { max-width: 420px; }
.ls-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem 0.75rem;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  font-weight: 700;
  font-size: 0.9rem;
}
.ls-modal-body { padding: 1rem 1.2rem; }
.ls-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1.2rem;
  border-top: 1px solid rgba(255,255,255,0.07);
}
.ls-modal--crear { max-width: 520px; }
.ls-form-field { margin-bottom: 0.85rem; }
.ls-form-field label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--q-gold, #f5a623);
  margin-bottom: 0.3rem;
}
.ls-form-field--inline { margin-top: -0.3rem; }
.ls-check-label {
  display: flex !important;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: var(--q-text) !important;
  cursor: pointer;
}
.ls-check { width: 15px; height: 15px; accent-color: var(--q-gold, #f5a623); cursor: pointer; flex-shrink: 0; }
.ls-input {
  width: 100%;
  background: var(--q-input-bg, #0e1622);
  color: var(--q-text, #c8d6e5);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 0.4rem;
  padding: 0.4rem 0.65rem;
  font-size: 0.85rem;
}
.ls-input:focus { outline: none; border-color: var(--q-gold, #f5a623); }
.ls-hint { font-size: 0.7rem; opacity: 0.6; text-transform: none; font-weight: 400; letter-spacing: 0; }
.ls-hint-warn { font-size: 0.78rem; color: #ffc107; margin-top: 0.3rem; }
.ls-section-label {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--q-gold, #f5a623);
  margin-bottom: 0.5rem;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid rgba(245,166,35,0.15);
}
.ls-servicio-info {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}
.ls-info-chip {
  font-size: 0.75rem;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 999px;
  padding: 0.15rem 0.6rem;
  color: var(--q-text, #c8d6e5);
}
.ls-info-chip--gold {
  background: rgba(245,166,35,0.1);
  border-color: rgba(245,166,35,0.3);
  color: var(--q-gold, #f5a623);
}
/* Toggle switch */
.ls-toggle-row { margin-bottom: 0.75rem; }
.ls-toggle-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  font-size: 0.85rem;
  user-select: none;
}
.ls-toggle-input { display: none; }
.ls-toggle-track {
  width: 36px;
  height: 20px;
  background: rgba(255,255,255,0.12);
  border-radius: 999px;
  flex-shrink: 0;
  position: relative;
  transition: background .2s;
}
.ls-toggle-input:checked + .ls-toggle-track { background: var(--q-gold, #f5a623); }
.ls-toggle-thumb {
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform .2s;
}
.ls-toggle-input:checked + .ls-toggle-track .ls-toggle-thumb { transform: translateX(16px); }
/* Panel precio */
.ls-precio-panel {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 0.6rem;
  padding: 0.85rem;
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}
.ls-precio-preview {
  font-size: 0.8rem;
  opacity: 0.7;
}
.ls-precio-input-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.ls-moneda-badge {
  font-size: 0.8rem;
  font-weight: 700;
  background: rgba(255,255,255,0.08);
  border-radius: 0.35rem;
  padding: 0.35rem 0.6rem;
  white-space: nowrap;
}
.ls-gratis-badge {
  font-size: 0.8rem;
  background: rgba(245,166,35,0.08);
  border: 1px solid rgba(245,166,35,0.2);
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: var(--q-gold, #f5a623);
}
.text-gold { color: var(--q-gold, #f5a623); }

/* Botón de configurar bloques */
.ls-btn-bloques {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(245,166,35,0.06);
  border: 1.5px dashed rgba(245,166,35,0.35);
  border-radius: 0.5rem;
  padding: 0.6rem 0.85rem;
  color: var(--q-gold, #f5a623);
  font-size: 0.83rem;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: background .15s, border-color .15s;
}
.ls-btn-bloques:hover:not(:disabled) { background: rgba(245,166,35,0.1); border-color: rgba(245,166,35,0.6); }
.ls-btn-bloques:disabled { opacity: 0.4; cursor: not-allowed; }

/* Modal bloques — desktop */
.ls-modal--bloques {
  max-width: 640px;
  height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ls-modal--bloques .ls-modal-body { padding: 0; }
.ls-bloques-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  padding: 1rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

/* Bottom sheet en móvil */
@media (max-width: 640px) {
  .modal-overlay { align-items: flex-end; padding: 0; }
  .ls-modal--bloques {
    max-width: 100%;
    width: 100%;
    height: 92vh;
    border-radius: 1rem 1rem 0 0;
  }
}
.ls-bloques-empty { text-align: center; padding: 2rem 1rem; }

/* Bloque card */
.ls-bloque-card {
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 0.55rem;
  overflow: hidden;
  background: rgba(255,255,255,0.025);
}
.ls-bloque-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.75rem;
  cursor: pointer;
  user-select: none;
  transition: background .12s;
}
.ls-bloque-head:hover { background: rgba(255,255,255,0.04); }
.ls-bloque-icon { color: var(--q-gold, #f5a623); font-size: 0.8rem; flex-shrink: 0; }
.ls-bloque-label { font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: var(--q-gold, #f5a623); flex-shrink: 0; }
.ls-bloque-preview { font-size: 0.78rem; opacity: 0.5; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; min-width: 0; }
.ls-bloque-actions { display: flex; align-items: center; gap: 2px; flex-shrink: 0; }
.ls-blk-btn {
  background: none; border: none;
  color: var(--q-text, #c8d6e5); opacity: 0.45;
  font-size: 0.7rem; padding: 3px 5px; border-radius: 3px; cursor: pointer;
}
.ls-blk-btn:hover:not(:disabled) { opacity: 0.9; background: rgba(255,255,255,0.06); }
.ls-blk-btn:disabled { opacity: 0.2; cursor: not-allowed; }
.ls-blk-btn--del:hover:not(:disabled) { color: #f87171; opacity: 1; }

.ls-bloque-fields { padding: 0.75rem 0.85rem; border-top: 1px solid rgba(255,255,255,0.06); }
.ls-textarea { resize: vertical; min-height: 72px; }

/* FAQ */
.ls-faq-scroll { max-height: 340px; overflow-y: auto; -webkit-overflow-scrolling: touch; overscroll-behavior: contain; }
.ls-faq-item { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07); border-radius: 0.4rem; padding: 0.65rem 0.75rem; margin-bottom: 0.6rem; }
.ls-faq-item-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.4rem; }
.ls-faq-num { font-size: 0.68rem; font-weight: 800; color: var(--q-gold, #f5a623); text-transform: uppercase; letter-spacing: .05em; }
.ls-btn-add-faq {
  background: none; border: 1px dashed rgba(255,255,255,0.15);
  color: var(--q-text-muted, #7b8ea8); font-size: 0.78rem;
  border-radius: 0.35rem; padding: 0.3rem 0.7rem; cursor: pointer; width: 100%;
}
.ls-btn-add-faq:hover { background: rgba(255,255,255,0.04); }

/* Capturas de reseñas */
.ls-capturas-label { font-size: 0.75rem; font-weight: 700; color: rgba(255,255,255,0.55); text-transform: uppercase; letter-spacing: .06em; margin: 0.75rem 0 0.5rem; }
.ls-capturas-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem; margin-bottom: 0.6rem; }
.ls-capturas-grid--imagen { grid-template-columns: repeat(2, 1fr); }
.ls-captura-item { position: relative; border-radius: 0.5rem; overflow: hidden; border: 1px solid rgba(255,255,255,0.08); aspect-ratio: 9/16; background: rgba(255,255,255,0.03); }
.ls-captura-item--imagen { aspect-ratio: unset; }
.ls-captura-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.ls-captura-img--fit { height: auto; object-fit: contain; max-height: 180px; }
.ls-caption-label { font-size: 0.72rem; color: rgba(255,255,255,0.45); font-weight: 600; }
/* VS block editor */
.ls-vs-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.ls-vs-slot { display: flex; flex-direction: column; gap: 6px; }
.ls-vs-slot-label { font-size: 0.72rem; font-weight: 700; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: .05em; }
.ls-vs-img-preview { position: relative; width: 80px; height: 80px; border-radius: 50%; overflow: hidden; border: 2px solid rgba(245,166,35,0.3); }
.ls-vs-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }
.ls-vs-img-preview .ls-captura-del { top: 0; right: 0; }
.ls-captura-del {
  position: absolute; top: 4px; right: 4px;
  width: 22px; height: 22px; border-radius: 50%;
  background: rgba(0,0,0,0.7); border: none; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.65rem; cursor: pointer;
  transition: background 0.15s;
}
.ls-captura-del:hover { background: rgba(220,50,50,0.85); }
.ls-btn-upload {
  display: inline-flex; align-items: center; gap: 0.4rem;
  cursor: pointer; font-size: 0.8rem; font-weight: 600;
  color: var(--q-gold, #f5a623);
  border: 1px dashed rgba(245,166,35,0.4);
  border-radius: 0.5rem; padding: 0.55rem 1rem;
  transition: background 0.15s, border-color 0.15s;
  width: 100%;
  justify-content: center;
}
.ls-btn-upload:hover { background: rgba(245,166,35,0.06); border-color: rgba(245,166,35,0.65); }
.ls-btn-upload--loading { opacity: 0.65; cursor: default; }

/* Añadir bloque */
.ls-add-bloque-wrap { display: flex; flex-direction: column; gap: 0.35rem; }
.ls-btn-add-bloque {
  width: 100%; background: none;
  border: 1px dashed rgba(255,255,255,0.12);
  color: var(--q-text-muted, #7b8ea8); font-size: 0.82rem;
  border-radius: 0.45rem; padding: 0.45rem; cursor: pointer;
  transition: background .12s, border-color .12s;
}
.ls-btn-add-bloque:hover { background: rgba(255,255,255,0.04); border-color: rgba(255,255,255,0.22); }
.ls-tipo-menu {
  background: var(--q-card, #1a2332);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 0.5rem;
  overflow: hidden;
}
.ls-tipo-item {
  display: flex; align-items: center;
  width: 100%; background: none; border: none; border-bottom: 1px solid rgba(255,255,255,0.05);
  padding: 0.55rem 0.9rem; font-size: 0.82rem;
  color: var(--q-text, #c8d6e5); cursor: pointer; text-align: left;
}
.ls-tipo-item:last-child { border-bottom: none; }
.ls-tipo-item:hover { background: rgba(245,166,35,0.08); color: var(--q-gold, #f5a623); }
.ls-form-check {
  font-size: 0.82rem;
  margin-bottom: 0.85rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.ls-alert { padding: 0.5rem 0.75rem; border-radius: 0.4rem; font-size: 0.82rem; }
.ls-alert--err { background: rgba(220,53,69,0.12); color: #f18d95; }

.det-close {
  background: none; border: none;
  color: var(--q-text, #c8d6e5); opacity: 0.45;
  font-size: 1rem; cursor: pointer;
  padding: 0.2rem 0.4rem; border-radius: 0.3rem;
}
.det-close:hover { opacity: 0.85; }

/* Preview móvil */
.ls-preview-box {
  background: var(--q-card, #0e141f);
  border: 1px solid var(--q-border, #1e2d3a);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 16px;
  max-height: 90vh;
}
.ls-preview-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ls-preview-title { font-size: .85rem; font-weight: 700; color: var(--q-text); }
.ls-preview-close {
  background: transparent; border: none;
  color: var(--q-muted); font-size: 1.1rem;
  cursor: pointer; padding: 2px 8px; border-radius: 4px;
}
.ls-preview-close:hover { color: var(--q-red, #ff4444); }
.ls-preview-phone {
  width: 375px; height: 667px;
  border: 3px solid var(--q-border-md, #2a3d50);
  border-radius: 16px;
  overflow: hidden; position: relative;
  background: #000;
  box-shadow: 0 0 40px rgba(0,0,0,.6);
  flex-shrink: 0;
}
.ls-preview-loading {
  position: absolute; inset: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.5rem; color: var(--q-muted);
}
.ls-preview-iframe { width: 100%; height: 100%; border: none; display: block; }
.ls-preview-footer { display: flex; gap: .5rem; }
@media (max-width: 600px) {
  .ls-preview-phone { width: 320px; height: 568px; }
}

/* Toast */
.ls-toast {
  position: fixed; bottom: 1.5rem; right: 1.5rem; z-index: 9999;
  padding: 0.6rem 1.1rem;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,0.4);
  animation: fadeIn 0.2s;
}
.ls-toast--ok  { background: #1d5e2a; color: #a8f0b8; }
.ls-toast--err { background: #5c1c22; color: #f8b4ba; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }

@media (max-width: 576px) {
  .ls-toolbar { flex-direction: column; align-items: stretch; }
  .btn-ls-primary { width: 100%; text-align: center; }
}
</style>
